export enum ScaleEnum {
  CONTAIN = "contain",
  CONTAIN_BLEED = "contain-bleed",
  FILL = "fill",
  FILL_BLEED = "fill-bleed",
  FULL = "full",
  SKETCH = "sketch",
  SKETCH_BLEED = "sketch-bleed",
}
